import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PagingNavItem } from '@hrra/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AnnouncementStatusEnum } from '@hrra/common-models';
import { CustomerStatusEnum } from 'src/app/customer/shared/models/enums/customer-status-enum';
import { loadApplications } from 'src/app/root-store/jobseeker-store/jobseeker-applies/actions';
import { selectVacancyApplicationsDisplayPages, selectVacancyApplicationsPageCount, selectAnnouncementAppliesCurrentPage, selectJobseekerVacancyApplications } from 'src/app/root-store/jobseeker-store/jobseeker-applies/selectors';
import { AppState } from 'src/app/root-store/state';
import { ApplicationStatusEnum } from 'src/app/shared/models/enums/application-statu-enum';
import { JobseekerOwnApplicationListRecord } from 'src/app/shared/models/jobseeker-application-model';

@Component({
    selector: 'app-jobseeker-applies-vacancy',
    templateUrl: './redesign/jobseeker-applies-vacancy.component.html',
    styleUrls: ['./redesign/jobseeker-applies-vacancy.component.scss'],
    standalone: false
})
export class JobseekerAppliesVacancyComponent implements OnInit {

  public applicationStatusNameMap = {
    [ApplicationStatusEnum.Pending]: 'label.Pending',
    [ApplicationStatusEnum.Approved]: 'label.ApplicationSent',
    [ApplicationStatusEnum.Rejected]: 'label.Rejected'
  };

  public applicationStatus: any;
  public announcementStatus: any;
  public customerStatus: any;

  public vacancyApplications$: Observable<JobseekerOwnApplicationListRecord[]>;
  public pageCount$: Observable<number>;
  public navItems$: Observable<PagingNavItem[]>;
  public currentPage$: Observable<number>;
  public isLoading$: Observable<boolean>;

  constructor(private store: Store<AppState>, private route: ActivatedRoute, private router: Router) { 
    this.applicationStatus = ApplicationStatusEnum;
    this.announcementStatus = AnnouncementStatusEnum;
    this.customerStatus = CustomerStatusEnum;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.store.dispatch(loadApplications({payload: { page: 1 }}));
    }, 0);

    this.vacancyApplications$ = this.store.pipe(select(selectJobseekerVacancyApplications));
    this.pageCount$ = this.store.pipe(select(selectVacancyApplicationsPageCount));
    this.navItems$ = this.store.pipe(select(selectVacancyApplicationsDisplayPages));
    this.currentPage$ = this.store.pipe(select(selectAnnouncementAppliesCurrentPage));
  }

  onPagignNavigation(page: number){
    this.store.dispatch(loadApplications({payload: { page: page }}));
  }
}
